import './App.css';
import React, { useEffect,useState } from 'react';
import Header from './Header';
import Home from './Home';
import Checkout from'./Checkout'
import Login from './Login';
import { BrowserRouter as Router, Switch, Route  }
from 'react-router-dom';
import {auth} from './firebase';
import {useStateValue} from './StateProvider';
import Payment from './Payment'
import Footer from './Footer'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from './Orders';

const promise = loadStripe(
  "pk_test_51Irq2MCEzOSVHZDwVUQO85VX7pw5SMpYzNGTOWSuRtgM0HZeQssAG0A7oeOe49qXyf39ilNKTggVYMiVv0OT9ami00TSYJjNmq"
);


function App() {
  const [{},dispatch] = useStateValue();

  useEffect(() => {
    // will only run once when the app component loads...

    auth.onAuthStateChanged((authUser) => {
      console.log("THE USER IS >>> ", authUser);

      if (authUser) {
        // the user just logged in / the user was logged in

        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <Router>
      <div className="app">
      
        <Switch>
          <Route path='/orders'>
          <Header/>
              <Orders/>
          <Footer/>
          </Route>
          <Route path='/login'>
              <Login/>
          </Route>
          
          <Route path='/checkout'>
            <Header/>
            <Checkout/>
            <Footer/>
          </Route>
          <Route path='/payment'>
            <Header/>
            <Elements stripe={promise}>
            <Payment/>
            </Elements>
            <Footer/>
          </Route>
          <Route path='/'>
            <Header/>
            <Home/>
            <Footer/>
          </Route>

          
        </Switch>   
    </div> 
    </Router>
    
  );
}

export default App;
